type ClassValue = string | number | false | null | undefined | ClassValue[]

/** Junta classes condicionais. Mais simples que `clsx` e sem dependência. */
export function cn(...values: ClassValue[]): string {
  const out: string[] = []
  for (const value of values) {
    if (!value) continue
    if (Array.isArray(value)) {
      const nested = cn(...value)
      if (nested) out.push(nested)
    } else {
      out.push(String(value))
    }
  }
  return out.join(' ')
}
